export const MEDICINE_TAKING_FETCH_REQUEST = 'MEDICINE_TAKING_FETCH_REQUEST';
export const MEDICINE_TAKING_FETCH_SUCCESS = 'MEDICINE_TAKING_FETCH_SUCCESS';
export const MEDICINE_TAKING_FETCH_FAILURE = 'MEDICINE_TAKING_FETCH_FAILURE';

export const MEDICINE_TAKING_SET_DATE = 'MEDICINE_TAKING_SET_DATE';